<template>
  <v-container fluid class="rbu-item" style="zoom: 85%" v-if="item">
    <div class="fixed-rbu-header">
      <v-row class="flex-grow-0">
        <v-btn
          text
          color="primary"
          exact
          :to="{
            name: 'rbu-section-detail',
            params: { sectionId: item.section.id },
          }"
        >
          <h3 class="font-weight-regular">
            &lt;&lt; {{ item.section.order_no }}. {{ item.section.name }}
          </h3>
        </v-btn>
      </v-row>
      <v-row class="rbu-item-info-wrapper">
        <v-btn
          color="primary"
          class="ml-4"
          @click="() => createItem(false, (title = 'Add New RBU Item'))"
          >Add New</v-btn
        >
        <v-btn
          color="primary"
          class="ml-4"
          @click="
            () =>
              createItem(
                true,
                `Duplicate RBU item with current item [${item.dummy_item_no}]`
              )
          "
          >Duplicate to New
        </v-btn>
        <v-btn color="primary" class="ml-4" @click="() => duplicateToPrevious()"
          >Duplicate to Previous
        </v-btn>
        <v-btn
          color="primary"
          class="ml-4"
          v-if="item.need_manual_update"
          @click="markItemUpdated"
          >Mark Updated
        </v-btn>
        <v-btn color="primary" class="ml-4" @click="save"
          >Save <span v-if="isChanged">*</span></v-btn
        >
        <!-- <v-btn
          color="primary"
          class="ml-4"
          :disabled="export_loading"
          @click="exportExcel"
          >Export Excel</v-btn
        > -->
        <v-btn
          color="primary"
          class="ml-4"
          :disabled="export_loading"
          @click="exportPDF"
          >Export as PDF</v-btn
        >
      </v-row>
    </div>

    <div style="margin-top: 4rem" id="rbu-item-pdf">
      <div>
        {{ generateErrorText }}
      </div>
      <div class="rbu-item-no-inputs">
        <v-text-field
          v-if="item.previous_item_no"
          filled
          readonly
          label="Previous Item No."
          hide-details="auto"
          v-model="item.previous_item_no"
        ></v-text-field>
        <v-text-field
          v-else
          filled
          readonly
          label="Previous Item No."
          hide-details="auto"
          value="New Item"
        ></v-text-field>
        <v-text-field
          filled
          readonly
          label="Dummy Item No."
          hide-details="auto"
          v-model="item.dummy_item_no"
        ></v-text-field>
        <v-text-field
          filled
          readonly
          label="Current Item No."
          hide-details="auto"
          v-model="item.current_item_no"
        ></v-text-field>
      </div>

      <div class="rbu-item-description-wrapper" v-if="item">
        <label>Descriptions</label>
        <div class="rbu-item-descriptions">
          <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Sub Section</div>
            <div v-if="item" class="rbu-item-description-content">
              {{ item.sub_section_name }}
            </div>
          </div>

          <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">
              Sub Section Description
            </div>
            <div v-if="item" class="rbu-item-description-content">
              <span v-html="item.sub_section_descriptions || '-'"></span>
            </div>
          </div>

          <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Unit</div>
            <div class="rbu-item-description-content">
              {{ item.unit || "-" }}
            </div>
          </div>

          <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Unit Description</div>
            <div class="rbu-item-description-content">
              <span v-html="item.unit_desc || '-'"> </span>
            </div>
          </div>

          <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Publication 1</div>
            <div class="rbu-item-description-content">
              <span v-html="item.printed_description || '-'"></span>
            </div>
          </div>
          <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Publication 2</div>
            <div class="rbu-item-description-content">
              <span v-html="item.printed_remarks || '-'"> </span>
            </div>
          </div>
          <!-- <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Search 1</div>
            <div class="rbu-item-description-content">
              <span v-html="item.search_one || '-'"> </span>
            </div>
          </div> -->
          <!-- <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Search 2</div>
            <div class="rbu-item-description-content">
              <span v-html="item.search_two || '-'"> </span>
            </div>
          </div> -->
          <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Category</div>
            <div
              class="rbu-item-description-content"
              v-html="
                item.category_definition
                  ? JSON.parse(item.category_definition).join('; ')
                  : ''
              "
            ></div>
          </div>
          <div class="rbu-item-description-row">
            <div class="rbu-item-description-title">Full Name</div>
            <div class="rbu-item-description-content">
              <span v-html="item.full_name || '-'"> </span>
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          margin-top: 1rem;
          max-width: 500px;
        "
      >
        <span style="width: 7rem">Remarks</span>
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Item Remark"
          :value="item.item_remark"
          @input="onItemUpdate({ item_remark: $event })"
        ></v-textarea>
      </div>

      <RbuItemAdoptedRate
        :item="item"
        @update="onItemUpdate"
      ></RbuItemAdoptedRate>

      <RbuItemEditor
        :item="item"
        @update="onItemUpdate"
        v-model="modules"
      ></RbuItemEditor>
    </div>
  </v-container>
</template>
<script>
import { onMounted, ref, watch, computed, provide } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import RbuItemEditor from "@/components/rbu/RbuItemEditor.vue";
import RbuItemAdoptedRate from "@/components/rbu/RbuItemAdoptedRate.vue";
import CreateRbuItemDialog from "@/components/rbu/CreateRbuItemDialog.vue";
import DuplicateToPreviousDialog from "@/components/rbu/DuplicateToPreviousDialog.vue";

export default {
  name: "RbuItem",
  components: { RbuItemAdoptedRate, RbuItemEditor },
  beforeRouteLeave(to, from, next) {
    if (this.isChanged) {
      const answer = window.confirm(
        "There is unsaved changes, are you sure to leave?"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  setup(props, { root }) {
    const item = ref(null);
    const edition = ref(null);
    provide(
      "RBU_EDITION_DATASET",
      computed(() => {
        return edition.value ? edition.value.selected_dataset : null;
      })
    );
    let cloneItem = null;
    const isChanged = ref(false);
    const export_loading = ref(false);
    const getItem = async function (non_blocking = false) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/item/",
        params: { item_id: root.$route.params.itemId },
        opt: {
          non_blocking,
        },
      });

      if (response.body.success) {
        item.value = response.body.item;

        if (!item.value.adjustment_percentage_formula) {
          item.value.adjustment_percentage = 100;
        }

        if (!item.value.adjustment_value_formula) {
          item.value.adjustment_value = 0;
        }

        if (!item.value.rounding) {
          item.value.rounding = "0.1";
        }

        // init unit for old items if null
        if (
          item.value &&
          item.value.previous_item &&
          item.value.previous_item.item_group &&
          item.value.previous_item.item_group.sub_sub_section &&
          item.value.previous_item.item_group.sub_sub_section.unit &&
          item.value.module_groups
        ) {
          for (const module_group of item.value.module_groups) {
            for (const module of module_group.modules) {
              if (!module.tender_rate_unit) {
                module.tender_rate_unit =
                  item.value.previous_item.item_group.sub_sub_section.unit;
              }
              if (!module.datapoint_unit) {
                module.datapoint_unit =
                  item.value.previous_item.item_group.sub_sub_section.unit;
              }
            }
          }
        }

        cloneItem = JSON.parse(JSON.stringify(item.value));
        isChanged.value = false; // Reset
      }
    };

    const createItem = async function (duplicate, title = "Create RBU Item") {
      await save();

      const itemId = await root.$dialog.showAndWait(CreateRbuItemDialog, {
        showClose: false,
        persistent: true,
        sectionId: item.value.section.id,
        title: title,
        duplicatedItemId: duplicate ? item.value.id : null,
      });

      if (itemId) {
        root.$router.replace({ name: "rbu-item", params: { itemId } });
      }
    };

    const duplicateToPrevious = async function () {
      await save();
      const title = `Duplicate to Previous Item from [${item.value.dummy_item_no}]`;
      const itemId = await root.$dialog.showAndWait(DuplicateToPreviousDialog, {
        showClose: false,
        persistent: true,
        sectionId: item.value.section.id,
        itemId: item.value.id,
        title: title,
      });

      if (itemId) {
        root.$router.replace({ name: "rbu-item", params: { itemId } });
      }
    };

    const onItemUpdate = function (evt) {
      item.value = {
        ...item.value,
        ...evt,
      };
    };
    const modules = ref([]);

    const markItemUpdated = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/item/mark_updated/",
        params: {
          item_id: root.$route.params.itemId,
        },
      });

      if (response.body.success) {
        getItem();
      }
    };
    const exportPDF = async function () {
      await save();

      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/item/generate_page_pdf/",
        params: {
          item_id: item.value.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get("content-filename"));
      link.click();

      getItem(true);
    };

    const save = async function () {
      async function processDatapoint(datapoint) {
        const file = datapoint.file
          ? datapoint.file instanceof File
            ? await root.$convertFileToBase64(datapoint.file)
            : datapoint.file.id
          : null;
        const filename = datapoint.file
          ? datapoint.file instanceof File
            ? datapoint.file.name
            : null
          : null;

        return {
          ...datapoint,
          file,
          filename,
        };
      }

      async function processTenderRates(tender_rate) {
        const file = tender_rate.file
          ? tender_rate.file instanceof File
            ? await root.$convertFileToBase64(tender_rate.file)
            : tender_rate.file.id
          : null;
        const filename = tender_rate.file
          ? tender_rate.file instanceof File
            ? tender_rate.file.name
            : null
          : null;

        return {
          ...tender_rate,
          file,
          filename,
        };
      }

      async function processFluctuation(fluctuation) {
        const file = fluctuation.file
          ? fluctuation.file instanceof File
            ? await root.$convertFileToBase64(fluctuation.file)
            : fluctuation.file.id
          : null;
        const filename = fluctuation.file
          ? fluctuation.file instanceof File
            ? fluctuation.file.name
            : null
          : null;

        return {
          ...fluctuation,
          previous_dataset: fluctuation.previous_datapoint
            ? fluctuation.previous_datapoint.dataset.id
            : null,
          previous_datapoint: fluctuation.previous_datapoint
            ? fluctuation.previous_datapoint.id
            : null,
          current_dataset: fluctuation.current_datapoint
            ? fluctuation.current_datapoint.dataset.id
            : null,
          current_datapoint: fluctuation.current_datapoint
            ? fluctuation.current_datapoint.id
            : null,
          file,
          filename,
        };
      }

      async function processModule(module) {
        const tender_rates = await Promise.all(
          (module.tender_rates || []).map(processTenderRates)
        );
        const datapoints = await Promise.all(
          (module.datapoints || []).map(processDatapoint)
        );
        const fluctuations = await Promise.all(
          (module.fluctuations || []).map(processFluctuation)
        );

        return {
          ...module,
          tender_rates,
          datapoints,
          fluctuations,
        };
      }

      async function processModuleGroup(module_group) {
        const modules = await Promise.all(
          module_group.modules.map(processModule)
        );

        return {
          ...module_group,
          modules,
        };
      }

      function numberToAlphabet(num) {
        let result = "";
        while (num >= 0) {
          let remainder = num % 26;
          result = String.fromCharCode(65 + remainder) + result;
          num = Math.floor(num / 26) - 1;
        }
        return result;
      }

      const module_groups = await Promise.all(
        item.value.module_groups.map(processModuleGroup)
      );

      let miss_unit = false;
      let miss_unit_error_msg = "";
      let miss_portion = false;
      let miss_portion_error_msg = "";
      let miss_census_rate = false;
      let miss_census_rate_error_msg = "";

      if (!item.value.adjustment_percentage_formula) {
        item.value.adjustment_percentage_formula = "";
        item.value.adjustment_percentage = "100";
      }

      if (!item.value.adjustment_value_formula) {
        item.value.adjustment_value_formula = "";
        item.value.adjustment_value = "0";
      }

      for (let i = 0; i < module_groups.length; i++) {
        const group = module_groups[i];
        if (!group.name) {
          // group.name = `Group ${numberToAlphabet(i)}`;
          group.name = "";
        }

        if (!group.adjustment_value_formula) {
          group.adjustment_value_formula = "";
          group.adjustment_value = "0";
        }

        if (!group.adjustment_percentage_formula) {
          group.adjustment_percentage_formula = "";
          group.adjustment_percentage = "100";
        }

        for (let j = 0; j < group.modules.length; j++) {
          const module = group.modules[j];
          if (!module.name) {
            // module.name = `Module ${numberToAlphabet(j)}`;
            module.name = "";
          }

          // check potion missing
          if (!module.portion) {
            miss_portion = true;
            miss_portion_error_msg += `Please fill in the Portion for Group ${numberToAlphabet(
              group.order_no
            )} - Module ${numberToAlphabet(module.order_no)} \n`;
          }

          // check adjustment_value_formula
          if (!module.adjustment_value_formula) {
            module.adjustment_value_formula = "";
            module.adjustment_value = "0";
          }

          //check adjustment_percentage_formula
          if (!module.adjustment_percentage_formula) {
            module.adjustment_percentage_formula = "";
            module.adjustment_percentage = "100";
          }

          if (
            module.base_rate_type === "TENDER_RATES" &&
            !module.tender_rate_unit
          ) {
            miss_unit = true;
            miss_unit_error_msg += `Please fill in the Unit for Tender Rates in Group ${numberToAlphabet(
              group.order_no
            )} - Module ${numberToAlphabet(module.order_no)} \n`;
          }

          if (module.base_rate_type === "DATAPOINT" && !module.datapoint_unit) {
            miss_unit = true;
            miss_unit_error_msg += `Please fill in the Unit for C&S cost data in Group ${numberToAlphabet(
              group.order_no
            )} - Module ${numberToAlphabet(module.order_no)} \n`;
          }

          for (const f of module.fluctuations) {
            if (!f.current_datapoint || !f.previous_datapoint) {
              miss_census_rate = true;
              miss_census_rate_error_msg += `Please complete the fluctuation census data in Group ${numberToAlphabet(
                group.order_no
              )} - Module ${numberToAlphabet(module.order_no)} \n`;
            }
          }
        }
      }

      if (miss_unit) {
        alert(miss_unit_error_msg);
        return;
      }

      if (miss_portion) {
        alert(miss_portion_error_msg);
        return;
      }

      if (miss_census_rate) {
        alert(miss_census_rate_error_msg);
        return;
      }

      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/item/set/",
        params: {
          item_id: root.$route.params.itemId,
          ...item.value,
          module_groups,
        },
      });

      if (response.body.success) {
        getItem();
      }
    };

    const calInBackend = async () => {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/item/re_cal/",
        params: {
          item_id: root.$route.params.itemId,
        },
      });

      if (response.body.success) {
        getItem();
      }
    };

    const generateErrorText = computed(() => {
      let error = [];

      try {
        if (item.value) {
          // for(const i in item.value.module_group){
          // }
          // if (item.value.module_group_summary_formula_error) {
          //   error.push("Item Summary Group Total Formula Error!");
          // }
        }
      } catch (e) {
        console.log(e);
      }
      return error.join("\n");
    });

    const getEdition = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/edition/",
        params: { edition_id: root.$route.params.editionId },
      });

      if (response.body.success) {
        edition.value = response.body.edition;
      }
    };

    onMounted(() => {
      getItem();
      getEdition();
    });

    function getDifferences(obj1, obj2, path = "") {
      if (path === ".beforeAdjustments") return;
      if (typeof obj1 !== "object" || obj1 === null) {
        if (obj1 != obj2) {
          console.debug(`Difference at ${path}:`, {
            original: obj1,
            current: obj2,
          });
          isChanged.value = true;
        }
      } else if (obj1 !== null && obj2 !== null) {
        Object.keys(obj1).forEach((key) => {
          if (key !== "beforeAdjustments" && !obj2.hasOwnProperty(key)) {
            console.debug(`Key '${key}' missing in obj2 at ${path}`);
            isChanged.value = true;
          } else {
            getDifferences(obj1[key], obj2[key], `${path}.${key}`);
          }
        });

        Object.keys(obj2).forEach((key) => {
          if (key !== "beforeAdjustments" && !obj1.hasOwnProperty(key)) {
            isChanged.value = true;
            console.debug(`Key '${key}' missing in obj1 at ${path}`);
          }
        });
      }
    }

    const exportExcel = async () => {
      // await save();
      // let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
      //   url: "admin/rbu/item/generate_excel/",
      //   params: {
      //     item_id: item.value.id,
      //   },
      //   opt: { extra: { responseType: "arraybuffer" } },
      // });
      // let blob = new Blob([response.data], {
      //   type: response.headers.get("content-type"),
      // });
      // let link = document.createElement("a");
      // link.href = window.URL.createObjectURL(blob);
      // link.download = decodeURI(response.headers.get("content-filename"));
      // link.click();
      // getItem(true);
    };

    watch(
      item,
      (newValue) => {
        isChanged.value = false;
        getDifferences(cloneItem, newValue);
      },
      { deep: true }
    );

    watch(
      () => root.$route.params.itemId,
      (newValue) => {
        getItem();
        getEdition();
      },
      { immediate: true }
    );

    return {
      item,
      modules,
      createItem,
      onItemUpdate,
      markItemUpdated,
      save,
      exportPDF,
      export_loading,
      isChanged,
      calInBackend,
      generateErrorText,
      exportExcel,
      duplicateToPrevious,
    };
  },
};
</script>

<style lang="less">
.rbu-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .fixed-rbu-header {
    position: fixed;
    top: 5rem;
    padding-top: 1rem;
    width: 100%;
    background-color: #efeeee;
    z-index: 10; /* Adjust as needed */
  }

  .rbu-item-info-wrapper {
    flex: 0 0 auto;
    display: flex;
    margin: 0;
    padding-right: 8rem;
    justify-content: flex-end;
  }

  .rbu-item-no-inputs {
    margin-top: 8px;
    flex: 0 0 auto;
    display: flex;
    gap: 12px;
  }

  .rbu-item-description-wrapper {
    margin-top: 16px;

    .rbu-item-descriptions {
      padding: 16px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 8px;

      .rbu-item-description-row {
        display: flex;
        padding: 4px;
        align-items: center;

        .rbu-item-description-title {
          flex: 0 0 auto;
          color: rgba(0, 0, 0, 0.4);
          margin-right: 12px;
        }

        .rbu-item-description-content {
          flex: 1 1 0;
        }
      }
    }
  }
}
</style>

<style scoped>
::v-deep .v-input__slot::before {
  border-style: none !important;
}
</style>
